import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { GridHookForm } from 'vnetwork-ui'

interface FinanceTabProps {
    formControl: UseFormReturn<any>
    onNext?: () => void
    onPrevious?: () => void
}

const FinanceTab: React.FC<FinanceTabProps> = ({
    formControl,
    onNext,
    onPrevious,
}) => {
    const { t } = useTranslation()

    return (
        <GridHookForm
            subForm={true}
            actions={[
                {
                    title: t('employees.previous_step'),
                    type: 'button',
                    variant: 'outlined',
                    handler: () => {
                        formControl?.handleSubmit(onPrevious as any)()
                    },
                },
                {
                    title: t('employees.next_step'),
                    type: 'button',
                    variant: 'contained',
                    handler: () => {
                        formControl?.handleSubmit(onNext as any)()
                    },
                },
            ]}
            formControl={formControl}
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
            data={[
                {
                    formItemProps: {
                        type: 'textfield',
                        name: 'employee_bank_name',
                        // disabled: true,
                        placeholder: t('employees.bank_name'),
                        label: t('employees.bank_name'),
                        className: 'md:col-span-2',
                    },
                },
                {
                    formItemProps: {
                        type: 'textfield',
                        name: 'employee_bank_branch',
                        placeholder: t('employees.bank_branch'),
                        label: t('employees.bank_branch'),
                    },
                },
                {
                    formItemProps: {
                        type: 'textfield',
                        name: 'employee_bank_number',
                        placeholder: t('employees.bank_number'),
                        label: t('employees.bank_number'),
                    },
                    className: 'md:col-span-2',
                },
                {
                    formItemProps: {
                        type: 'textfield',
                        name: 'employee_personal_tax_code',
                        placeholder: t('employees.personal_tax_code'),
                        label: t('employees.personal_tax_code'),
                    },
                    className: 'md:col-span-2',
                },
                {
                    formItemProps: {
                        type: 'textfield',
                        name: 'employee_health_insurance',
                        placeholder: t('health-insurance'),
                        label: t('health-insurance'),
                    },
                },
                {
                    formItemProps: {
                        type: 'textfield',
                        name: 'employee_social_insurance',
                        placeholder: t('social-insurance'),
                        label: t('social-insurance'),
                    },
                },
                {
                    formItemProps: {
                        type: 'textfield',
                        name: 'employee_medical_registration_place',
                        placeholder: t('place-to-register'),
                        label: t('place-to-register'),
                    },
                    className: 'md:col-span-2',
                },
            ]}
        />
    )
}

export default FinanceTab
